import { Component, Input, OnInit } from '@angular/core';

import { TelematicsEvent } from '../../enums/TelematicsEvent';

@Component({
  selector: 'app-telematics-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  imports: [],
})
export class TelematicsEventsComponent implements OnInit {
  @Input() events: Array<any> = [];

  ngOnInit() {
    console.log('Events data:', this.events);
    if (this.events?.length > 0) {
      console.log('First event:', this.events[0]);
      console.log('Type of first event:', typeof this.events[0]);
    }
  }

  public setStatusIcon(value: any): string {
    // Handle the event ID, whether it's passed directly or as an object property
    const eventId = Number(value);

    let text = '';
    switch (eventId) {
      case TelematicsEvent.Acceleration:
        text = 'icon-acceleration';
        break;
      case TelematicsEvent.HardBraking:
        text = 'icon-hard-braking';
        break;
      case TelematicsEvent.HardReturn:
        text = 'icon-hard-return';
        break;
      case TelematicsEvent.PhoneUsed:
        text = 'icon-phone-used';
        break;
      case TelematicsEvent.SpeedLimit:
        text = 'icon-speed-limit';
        break;
      default:
        console.log('No matching event type for:', eventId);
    }

    return text;
  }

  public getEventTitle(value: any): string {
    const eventId = Number(value);

    switch (eventId) {
      case TelematicsEvent.Acceleration:
        return 'Acceleration';
      case TelematicsEvent.HardBraking:
        return 'Hard Braking';
      case TelematicsEvent.HardReturn:
        return 'Hard Return';
      case TelematicsEvent.PhoneUsed:
        return 'Phone Used';
      case TelematicsEvent.SpeedLimit:
        return 'Speed Limit';
      default:
        return `Event Type: ${eventId}`;
    }
  }
}
